/* global require */
'use_strict';

declare global {
  interface Window {
    fcWidget: any;
  }
}

/**
 * Manages site wide navigation scripts.
 */
export class SiteNavigation {

    constructor() {
        if (window.innerWidth < 767) {
            window.onload = () => {
                this.handle_mobile_navigation();
                this.manage_freshdesk();
            }
        }
    }

    /**
     * Handle the mobile navigation for better UX.
     * 
     * @returns {void}
     */
    handle_mobile_navigation() : void {
        const nav_background = document.querySelector('ul.ut2-menu__list') as HTMLElement;
        const main_container = document.querySelector('#tygh_main_container') as HTMLElement;
        nav_background.style.height = main_container.offsetHeight + 'px';

        
        let current_position = 0;
        const mobile_search_opener = document.getElementsByClassName('cm-external-trigger')[0];
        const mobile_menu_toggle_button = document.getElementsByClassName('ut2-h__menu__burger')[0];

        mobile_search_opener?.addEventListener('click', () => {
            current_position = window.scrollY;
            setTimeout(function() {window.scrollTo(0, 0);}, 0);
        });

        mobile_menu_toggle_button?.addEventListener('click', () => {
            if (!mobile_menu_toggle_button.classList.contains('open')) {
                window.scrollTo(0, current_position);
                return;
            }
        });

        
    }

    /**
     * Handle the opening of the FreshDesk icon on mobile. 
     * 
     * @returns {void}
     */
    manage_freshdesk() : void {
        const freshdesk_opener = document.getElementById('js-mobile-freshdesk-opener');

        freshdesk_opener?.addEventListener('click', () => {
            window.fcWidget.open();
        });
    }
}

/**
 * Initialize the site wide navigation class.
 * @return {void}
 */
export function init_site_navigation() {
    if (document.getElementsByClassName('cm-external-triggered')[0]) {
        (() => new SiteNavigation())();
    }
}